module.exports = __webpack_public_path__ + "img/vanessa-beauregard.fa421fd0.png";